<p-confirmDialog #deleteUserDialog
                 [style]="{width: 'fit-content', paddingBottom : '1%' ,color: 'red', fontWeight: 'bold'}"
                 key="deleteUserDialog">
  <ng-template>
    <div class="alert alert-danger alert-dismissible fade show">
      <button (click)="error = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button (click)="deleteUserDialog.accept()" class="btn btn-outline-danger button-size pull-right" type="reset">
      <i aria-hidden="true" class="fa fa-check pr-2"></i>
      Delete
    </button>
    <button (click)="deleteUserDialog.reject()" class="btn btn-outline-success button-size pull-right" type="reset">
      <i aria-hidden="true" class="fa fa-times pr-2"></i>
      Cancel
    </button>
    <br>
  </ng-template>
</p-confirmDialog>

<nav class="navbar navbar-expand navbar-light bg-light mb-3" id="new-breadcrumb-sf4">
  <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
    <ol *ngIf="!loading" class="breadcrumb ol-sf-1">
      <li class="breadcrumb-item">
        <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
        <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
      </li>
      <li *ngIf="getUserCurrent().company.uniqid === 'admin'" class="breadcrumb-item">
        <a routerLink="/{{getUserCurrent().company.uniqid}}/company">List companies</a>
      </li>
      <li *ngIf="getUserCurrent().company.uniqid === 'admin' && currentCompany" class="breadcrumb-item">
        <a
          routerLink="/{{getUserCurrent().company.uniqid}}/company/{{currentCompany?.uniqid}}/edit">{{ currentCompany?.name }}</a>
      </li>
      <li *ngIf="currentCompany" class="breadcrumb-item">
        List users
      </li>
    </ol>
  </nav>
</nav>
<div *ngIf="notAuthorized">
  You don't have the required permission to access this page.
</div>
<div *roles="['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DEVELOPER', 'ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN', 'ROLE_CLIENT_DEVELOPER']"
     class="pb-2 mb-3 border-bottom">
  <h3>
    <b>List {{ getFirstUserCompanyName() }} users </b><i *ngIf="oneUserWithDifferentDomainName"
                                                         class="fa fa-exclamation-circle"
                                                         style="color: red"
                                                         title="Caution: at least one of the users has an unexpected email's domain name. Please check."></i>
  </h3>
  <h6>
    <div class="users-width" *ngIf="currentCompany?.activeUsers">Active
      users:  {{ currentCompany.activeUsers + '/' + currentCompany.totalUsers }}
    </div>
  </h6>
</div>

<div *ngIf="userNotFound" class="alert alert-warning alert-dismissible fade show">
  User not found.
  <button (click)="userNotFound = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="success" class="alert alert-success alert-dismissible fade show">
  {{ successMessage }}
  <button (click)="success = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
  An error occurred while processing your request.
  <button (click)="error = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="authorizationError" class="alert alert-danger alert-dismissible fade show">
  {{ authorizationErrorMessage }}
  <button (click)="authorizationError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="deleteLastSuperUserError" class="alert alert-danger alert-dismissible fade show">
  Cannot delete this user because they are the last active user for at least one assigned role.
  <button (click)="deleteLastSuperUserError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="successInvalidateUser" class="alert alert-success alert-dismissible fade show">
  The user has been updated.
  <button (click)="successInvalidateUser = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="errorInvalidateUser" class="alert alert-danger alert-dismissible fade show">
  {{ this.validateUserErrorMessage }}
  <button (click)="errorInvalidateUser = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="row">
  <div class="col-12">
    <p-panel [toggleable]="true">
      <ng-template pTemplate="header">
        <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
      </ng-template>
      <div class="row">
        <div class="form-group col-4">
          <p-floatLabel>
            <input [(ngModel)]="userSearchCriteria.nameOrEmail" (ngModelChange)="filteredUsers()" autocomplete="off"
                   class="form-control" data-lpignore="true" type="text">
            <label>Name or email</label>
          </p-floatLabel>
        </div>
        <div *ngIf="billingAccountCheckBoxes?.length > 0" class="form-group col-8" style="padding-top: 25px;">
          <div class="row">
            <label class="control-label col-2">Billing account</label>
            <div class="col-10">
              <p-selectButton [(ngModel)]="userSearchCriteria.billingAccount" (ngModelChange)="filteredUsers()"
                              [options]="billingAccountCheckBoxes" id="billing_account_filter"
                              multiple="multiple"></p-selectButton>
            </div>
          </div>
        </div>
        <div class="form-group col-12">
          <div class="row">
            <label class="control-label col-1">Roles</label>
            <div class="col-10 row">
              <p-selectButton [(ngModel)]="userSearchCriteria.roles" [options]="roleCheckBoxes" (ngModelChange)="filteredUsers()"
                              multiple="multiple"></p-selectButton>
              <button (click)="displayItem($event,op1)" (close)="op1.hide()" icon="fa fa-info pr-2" iconPos="left" id="roles_information_button"
                      label="More about roles"
                      pButton style="margin-left: 10px" type="button"></button>
            </div>
            <div class="col-1">
              <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="reset_button" label="Reset" pButton
                      style="float:right; margin-left: 10px" type="button"></button>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
    <p-overlayPanel #op1 [dismissable]="true" [style]="{width: '40%'}" appendTo="body">
      <table style="color:#333333;border-width:1px;border-color:#666666;border-collapse: collapse; width: 100%">
        <tr>
          <th
            style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666;background-color: #dedede;">
            Name
          </th>
          <th
            style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666;background-color: #dedede;">
            Purpose
          </th>
        </tr>

        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Operations</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Sent announcements
            regarding planned and unplanned outages, upgrades, performance and symbol roll notifications.
          </td>
        </tr>
        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Developer</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Download libraries, API,
            other documentation.
          </td>
        </tr>
        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Finance</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Sent invoices and
            billing-related emails.
          </td>
        </tr>
        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">Administrator</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">May create other users
            and grant their roles. Notifications on new services and improvements.
          </td>
        </tr>
        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">DAD Reporter</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">The DAD Report reports
            monthly data access for exchanges that have pass through billing.
          </td>
        </tr>
        <tr>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">MAC Permissioner</td>
          <td style="border-width: 1px;padding: 8px;border-style: solid;border-color: #666666">May access and modify the
            MAC Address form.
          </td>
        </tr>
      </table>
    </p-overlayPanel>
  </div>
</div>
<div *ngIf="!loading">
  <p-table #dt (sortFunction)="customSort($event)" [columns]="cols" [customSort]="true"
           [exportFilename]="getFilename()" [rowHover]="true"
           [tableStyle]="{'table-layout':'auto'}" [value]="filteredListUsers" id="users-list-table">
    <ng-template pTemplate="caption">
      <button
        (click)="quickExportCSV()"
        *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER', 'ROLE_CLIENT_ADMIN', 'ROLE_CLIENT_SUPER','ROLE_MCKAY_DEVELOPER','ROLE_MCKAY_OPERATIONS']" class="alert-light"
        icon="fa fa-download pr-2" iconPos="left" id="_quick_download_button"
        label="Quick export csv" pButton style="float:left; background-color: #DD6A31"
        type="button"></button>
      <span *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER','ROLE_MCKAY_DEVELOPER','ROLE_MCKAY_OPERATIONS']"
            style="font-size: 11px ;margin-left: 10px; float: left; margin-top: 8px;">
        This option exports the list of users, only for email, name, role, and last login columns.</span>
      <div class="p-helper-clearfix caption-buttons-container">
        <button
          (click)="dt.exportCSV()"
          *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER', 'ROLE_CLIENT_ADMIN', 'ROLE_CLIENT_SUPER','ROLE_MCKAY_DEVELOPER','ROLE_MCKAY_OPERATIONS']" icon="fa fa-download pr-2" iconPos="left"
          id="download_csv_button" label="Download csv"
          pButton style="float:right; margin-left: 10px" type="button"></button>
        <button *permission="['canAddUsers']" icon="fa fa-plus-circle pr-2" iconPos="left" id="add_top_button" label="Add User" pButton
                routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/user/new"
                style="float:right; margin-left: 10px"
                type="button">
        </button>
      </div>
    </ng-template>
    <ng-template let-columns pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [className]="col.class"
            [pSortableColumnDisabled]="col.sortDisabled"
            [pSortableColumn]="col.field"
            class="p-sortable-column ng-star-inserted" pTooltip="{{col.tooltip}}">
          {{ col.header }}
          <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template let-user pTemplate="body">
      <tr>
        <td>
          <i *ngIf="user?.isActive == 1" class="fa fa-check"></i>
          <br>
          <i *ngIf="isNotLoggedSinceSixMonthsAgo(user) && hasNotOnlyFinanceRole(user)" class="fa fa-exclamation-circle"
             style="color: red"
             title="Inactive user.">
          </i>
        </td>
        <td class="email-width">
          {{ user.emailShown }}
        </td>
        <td>
          <button class="btn btn-link" name="name_link" routerLink="/{{getUserCurrent()?.company?.uniqid}}/{{currentCompany?.uniqid}}/{{user?.uniqid}}/show" style="text-align: left"
                  type="button">{{ user?.name }}
          </button>
        </td>
        <td class="custom-checkbox">
          <div class="pl-10" id="checkbox-container">
            <div class="custom-control custom-checkbox">
              <input (change)="checkEmailNotifications(user)" [(ngModel)]="user.commercialOptIn" [disabled]="!canEditUsers()"
                     class="custom-control-input" id="commercialOptIn_{{user.uniqid}}"
                     type="checkbox">
              <label class="custom-control-label" for="commercialOptIn_{{user.uniqid}}"></label>
            </div>
          </div>
        </td>
        <td>
          {{ getMobilePhone(user) }}
        </td>
        <td>
          {{ parseToStringRoles(user) }}
        </td>
        <td>
          {{ getVisibleBillingAccounts(user).join(', ') }}<ng-container *ngIf="hasMoreBillingAccounts(user)">,
            <a (click)="toggleBillingAccountsExpansion(user, $event)" class="show-more-link" href="javascript:void(0)">{{ isBillingAccountsExpanded(user) ? '[less]' : '[more]' }}</a>
          </ng-container>
        </td>
        <td>
          <i *ngIf="isNotLoggedSinceSixMonthsAgo(user)" class="fa fa-exclamation-circle" style="color: red"
             title="The user's last login was more than 6 months ago.">
          </i>
          {{ user.lastLoginStringFormat }}
        </td>
        <td>
          {{ user.lastApiCalledStringFormat }}
        </td>
        <td class="action-width">
          <div class="d-flex flex-column">
            <button (click)="resetApiKey(user)" *ngIf="canResetUserApiKey(user)" class="btn btn-link no-padding-button"
                    name="reset_user_api_key_link"
                    type="button">
              <i aria-hidden="true" class="fa fa-refresh icon-color"></i>
              <span> Reset user API key</span>
            </button>
            <button (click)="reset2Fa(user)" *ngIf="user.hasSetupMfa" class="btn btn-link no-padding-button"
                    name="reset_user_api_key_link"
                    type="button">
              <i class="fa fa-qrcode"></i>
              <span> Reset 2FA</span>
            </button>
            <ng-container *ngIf="user.isActive === true && !user.isNotificationOnly">
              <button (click)="resetPassword(user)"
                      *ngIf="canDeleteOrResetPassword(user)"
                      class="btn btn-link no-padding-button"
                      name="reset_password_link"
                      type="button">
                <i aria-hidden="true" class="fa fa-random icon-color"></i>
                <span> Reset password</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user.isActive === false">
              <button (click)="resendInvitation(user)"
                      *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_SUPER','ROLE_CLIENT_ADMIN']"
                      class="btn btn-link no-padding-button"
                      name="reset_password_link" type="button">
                <i aria-hidden="true" class="fa fa-random icon-color"></i>
                <span> Resend invitation</span>
              </button>
            </ng-container>
            <ng-container *ngIf="!user?.isActive && currentCompany?.uniqid !== 'admin'">
              <button (click)="validateUser(user)" *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']" class="btn btn-link no-padding-button"
                      name="validate_user"
                      type="button">
                <i aria-hidden="true" class="fa fa-check icon-color"></i>
                <span> Validate user</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user?.isActive && currentCompany?.uniqid !== 'admin' && !isSuperUser(user)">
              <button (click)="invalidateUser(user)" *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']" class="btn btn-link no-padding-button"
                      name="invalidate_user"
                      title="McKay will not send any email to an invalid user. An invalid user can log back in anytime to be valid again."
                      type="button">
                <i aria-hidden="true" class="fa fa-ban icon-color"></i>
                <span> Invalidate user</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user?.uniqid !== getUserCurrent()?.uniqid">
              <button (click)="beforeDeleteUser(user)"
                      *ngIf="canDeleteOrResetPassword(user, true)" class="btn btn-link no-padding-button" name="delete_link"
                      type="button">
                <i aria-hidden="true" class="fa fa-close icon-color"></i>
                <span> Delete</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user?.hasDifferentDomain">
              <button (click)="confirmDomain(user)" *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']" class="btn btn-link no-padding-button"
                      name="confirm_domain_name_link"
                      type="button">
                <i aria-hidden="true" class="fa fa-check icon-color"></i>
                <span> Confirm domain name</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user?.serviceProvider">
              <button (click)="downloadAuthorization(user)" *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']"
                      class="btn btn-link no-padding-button"
                      name="download_authorization_as_PDF"
                      type="button">
                <i aria-hidden="true" class="fa  fa-file-pdf-o "></i>
                <i class="fa-thin fa-file-pdf fa-xs"></i>
                <span> Download authorization</span>
              </button>
            </ng-container>
          </div>
        </td>
        <td>
          <div class="d-flex flex-column">
            <ng-container *ngIf="user.uniqid !== getUserCurrent()?.uniqid">
              <button *ngIf="canEditUser(user)" class="btn btn-link no-padding-button" name="edit_user_link"
                      routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/{{user.uniqid}}/edit"
                      type="button">
                <i aria-hidden="true" class="fa fa-pencil icon-color"></i>
                <span> Edit</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user.uniqid == getUserCurrent().uniqid">
              <button *permission="['canEditYours']" class="btn btn-link no-padding-button" name="modify_my_info_link"
                      routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/{{user.uniqid}}/edit"
                      type="button">
                <i aria-hidden="true" class="fa fa-edit icon-color"></i>
                <span> Modify my info</span>
              </button>
            </ng-container>
            <ng-container *ngIf="user.uniqid !== getUserCurrent()?.uniqid">
              <button *notAllowedPermissions="['canEditUsers']" class="btn btn-link no-padding-button" name="modify_my_info_link"
                      routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/{{user.uniqid}}/show"
                      type="button">
                <i aria-hidden="true" class="fa fa-eye icon-color"></i>
                <span> Show</span>
              </button>
            </ng-container>
            <ng-container
              *ngIf="!isMckayUser(user) && currentCompany?.uniqid !== 'admin' && user.isActive &&  !user.isNotificationOnly">
              <button (click)="impersonateUser(user.email)" *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']" [disabled]="user.mustChangePassword"
                      class="btn btn-link no-padding-button" name="impersonate_user"
                      type="button">
                <i aria-hidden="true" class="fa fa-check icon-color"></i>
                <span>Impersonate User</span>
                <span *ngIf="user.mustChangePassword" style="color: red; font-size: 9px"> This user must change his password</span>
              </button>
            </ng-container>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      {{ getTotalUserRecords() }} results
    </ng-template>
  </p-table>

  <div class="d-flex justify-content-end buttons-margin-left mt-3">
    <button (click)="resetTable()" class="btn btn-outline-primary" id="reset_bottom_button" type="reset">
      <i aria-hidden="true" class="fa fa-refresh pr-2"></i>
      Reset
    </button>
    <button *ngIf="currentUser.permissions.canAddUsers" class="btn btn-outline-primary ml-2" id="add_bottom_button"
            routerLink="/{{getUserCurrent()?.company?.uniqid}}/{{currentCompany?.uniqid}}/user/new"
            type="button">
      <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>
      Add user
    </button>
  </div>
</div>
